// shows the group's payment history in a more simple table.
// similar to how github shows payment history
// 
// We may not need this.
export class SimplePaymentHistory extends HTMLElement {

  constructor(groupId, previousViewId) {
    super();
    this.groupId = groupId
    this.previousViewId = previousViewId
  }

  async init_invoices_table() {
      this.table = $(this.querySelector('#simple_payment_history')).DataTable({
      "ajax": `/admin/groups/${this.groupId}/invoices`,
      "createdRow": function( row, data, dataIndex ) {
          if ( data.stripe_invoice_paid === 0 ) {
            $(row).addClass( 'failed_payment' );
          }
        },
      "columns": [
        {
          "render": function( data, type, row ) {
            return moment(row.invoice_date).format("MMM DD, YYYY")
          },
          "class": "text-center"
        },

        {
          "render": function ( data, type, row ) {
            return row.stripe_invoice_number
          },
          "className" : "text-center"
        },
        {
          "render": function ( data, type, row ) {
            const clazz = (row.stripe_invoice_paid === 0) ? 'glyphiconno glyphicon-remove' : 'glyphiconyes glyphicon-ok' ;
            return "<i class='invoice_status " + clazz + "'></i>";
          },
          "className" : "text-center"
        },
        {
          "render": function ( data, type, row ) {
            // Simplify the paid with data for the simplified view
            let s = row.stripe_paid_with
            if (s) {
              s = s.replace("Credit Card: ",'')
              const i = s.indexOf('Expir')
              s = s.substr(0, i-1)
            }
            return s;
          },
          "className" : "text-center"
        },
        {
          "render": function ( data, type, row ) {
            return `<a 
                  href=${row.stripe_invoice_pdf_url}
                  title='Click to download invoice PDF'
                  class='text-center'>
                    <span class='text-center'>
                    <i class="fa fa-download" aria-hidden="true"></i>
                    </span>
                  </a>`
          },
          "className" : "text-center"
        },

      ],
      order: [[ 0, "asc" ]],
      initComplete: function () {
      },
    });  
  }
  
  group_invoices_html() {
    return `
          <h3><span id="campaign-back"></span> Payment History</h3>
          <table id="simple_payment_history" class="table datatable" style="width:100%">
            <thead>
                <tr>
                  <th>Date</th>
                  <th>ID</th>
                  <th>Status</th>
                  <th>Paid By</th>
                  <th>Receipt</th>
                </tr>
            </thead>
            <tbody>
            </tbody>
          </table>    
    `
  }
  
  async connectedCallback() { 
    const html = this.group_invoices_html()   
    this.innerHTML = 
      `<style>
        
      </style>

      ${html}
    `;

    await this.init_invoices_table()
    
    this.querySelector('#campaign-back').addEventListener('click', this.cancelEdit.bind(this));
  }

  cancelEdit(e) {
    e.preventDefault();
    this.remove();
    document.getElementById(this.previousViewId).style.display = 'initial';
  }

}
customElements.define('simple-payment-history', SimplePaymentHistory)